/*!
 *   keyfinder - v1.0.0
 *   Deep search for keys in objects and arrays and pluck their respective values.
 *   https://github.com/simon-johansson/keyfinder
 *   by Simon Johansson <mail@simon-johansson.com>
 *   MIT License
 */

(function() {
    var arrayify, find, isArray, isFunction, isObjectOrArray;
    isObjectOrArray = require("is-object");
    isArray = require("is-array");
    isFunction = require("is-function");
    arrayify = function(obj) {
        var key, _results;
        _results = [];
        for (key in obj) {
            _results.push(key);
        }
        return _results;
    };
    find = function(haystack, needle, memo) {
        var key, parent, val, _i, _len, _ref;
        if (memo == null) {
            memo = [];
        }
        if (needle && isObjectOrArray(haystack)) {
            if (needle in haystack) {
                memo.push(haystack[needle]);
            }
            _ref = arrayify(haystack);
            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                key = _ref[_i];
                val = haystack[key];
                if (isFunction(needle)) {
                    parent = isArray(haystack) ? "array" : "object";
                    needle(key, val, parent);
                }
                if (isObjectOrArray(val)) {
                    find(val, needle, memo);
                }
            }
        }
        return memo;
    };
    module.exports = function(obj, key) {
        return find(obj, key);
    };
}).call(this);